import Vue from 'vue';
import config from '@/config/index';
export default {
    //列表页相关
    // 查询
    getDeviceBrandPage(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/brand/page`,
            method: 'get',
            params
        })
    },
    // 新增设备品牌
    addDeviceBrand(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/brand/add`,
            method: 'post',
            data
        })
    },
    // 查询设备品牌详情
    getDeviceBrandDetail(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/brand/detail`,
            method: 'get',
            params
        })
    },
    //设备品牌树
    getDeviceBrandTree() {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/brand/tree`,
            method: 'get'
        })
    },
    // 根据设备类型获得设备品牌
    getDeviceBrandByType(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/brand/chose`,
            method: 'get',
            params
        })
    }
}